var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"plus","d":"M24.062,13.736H15.388V5.063H13.736v8.674H5.063v1.652h8.674v8.674h1.652V15.388h8.674V13.736Z","transform":"translate(-5.063 -5.063)","fill":"#fff"}));
}

Plus.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19"};

module.exports = Plus;

Plus.default = Plus;
